export default "__VITE_ASSET__B5jfX9jE__"